import { badgesConstants } from 'pages/integrations/containers/BadgesContainer/constants';

const initialState = {
  isLoading: true,
  isGroupsLoading: false,
  badgeConfigs: [],
  badgeGroups: [],
  error: null
};

export const fetchBadgesIntegrationData = (state = initialState, action) => {
  switch (action.type) {
    case badgesConstants.FETCH_BADGE_CONFIGS_REQUEST:
      return { ...state, isLoading: true };
    case badgesConstants.FETCH_BADGE_CONFIGS_SUCCESS:
      return { ...state, badgeConfigs: action.payload.data?.results || [], isLoading: false };
    case badgesConstants.FETCH_BADGE_CONFIGS_FAILURE:
      return { ...state, error: action.error, isLoading: false };
    case badgesConstants.FETCH_BADGE_GROUPS_REQUEST:
      return { ...state, isGroupsLoading: true };
    case badgesConstants.FETCH_BADGE_GROUPS_SUCCESS:
      return {
        ...state,
        badgeGroups: action.payload.data?.results || action.payload.data || [],
        isGroupsLoading: false
      };
    case badgesConstants.FETCH_BADGE_GROUPS_FAILURE:
      return { ...state, error: action.error, isGroupsLoading: false };
    case badgesConstants.CLEAR_BADGE_DATA:
      return { ...state, badgeConfigs: [], badgeGroups: [] };
    default:
      return state;
  }
};
